import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMountains = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 5.61484L8.54166 8.88984L10.4167 11.3898C10.6917 11.7565 10.6167 12.2815 10.25 12.5565C9.88333 12.8315 9.35833 12.7648 9.08333 12.3898C8.20833 11.2232 7.15833 9.83151 6.49999 8.93984C6.16666 8.49818 5.49999 8.49818 5.16666 8.93984L1.83333 13.3815C1.42499 13.9398 1.81666 14.7232 2.49999 14.7232H17.5C18.1833 14.7232 18.575 13.9398 18.1667 13.3898L12.3333 5.61484C12 5.16484 11.3333 5.16484 11 5.61484Z",
		fill: "currentColor"
	})
});
export default SvgMountains;
